export const ItemTypes  = {
    CELL : "CELL", // todo: consider renaming to SLEEVE
    LID : "LID"
};



// WEBPACK FOOTER //
// ./src/containers/steps/BuildSteps/BuildsComponent/ItemsTypes.js